import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { getSectionFromPath, NavSection } from '../config/navigation';

export function useActiveSection(): NavSection {
  const { pathname } = useLocation();

  return useMemo(() => getSectionFromPath(pathname), [pathname]);
}
